import de from "../images/flags/de.png"
import dk from "../images/flags/dk.png"
import et from "../images/flags/es.png"
import fi from "../images/flags/fi.png"
import fr from "../images/flags/fr.png"
import it from "../images/flags/it.png"
import no from "../images/flags/no.png"
import se from "../images/flags/se.png"
import sp from "../images/flags/sp.png"
import uk from "../images/flags/uk.png"

const images = { fi, se, dk, et, fr, it, no, sp, uk, de }

export default images